import type {
  MemoryEntry,
  UserModelObservation,
  UserModelResponse,
} from '../types/api'
import { api } from './client'

/**
 * An agent's written memory — what it chose to remember across turns. Stored
 * in the database, so it is readable and editable whether or not the agent is
 * running. Surfaced on the agent's profile page.
 */
export const memoryApi = {
  list: (wsId: string, agentId: string) =>
    api.get<MemoryEntry[]>(
      `/api/workspaces/${wsId}/agents/${encodeURIComponent(agentId)}/memory`,
    ),

  /** Creates or replaces the entry. `replaced` reports which it was. */
  write: (wsId: string, agentId: string, key: string, text: string) =>
    api.put<{ replaced: boolean }>(
      `/api/workspaces/${wsId}/agents/${encodeURIComponent(agentId)}/memory`,
      { key, text },
    ),

  remove: (wsId: string, agentId: string, key: string) =>
    api.delete<void>(
      `/api/workspaces/${wsId}/agents/${encodeURIComponent(agentId)}/memory/${encodeURIComponent(key)}`,
    ),
}

/**
 * Per-member user models — structured observations agents have recorded about
 * a specific workspace member. Members curate their own; managers can inspect
 * any member's.
 */
export const userModelApi = {
  getMine: (wsId: string) =>
    api.get<UserModelResponse>(`/api/workspaces/${wsId}/user-model`),

  addMine: (wsId: string, content: string) =>
    api.post<UserModelObservation>(`/api/workspaces/${wsId}/user-model`, {
      content,
    }),

  remove: (wsId: string, observationId: string) =>
    api.delete<void>(
      `/api/workspaces/${wsId}/user-model/${encodeURIComponent(observationId)}`,
    ),

  getForMember: (wsId: string, username: string) =>
    api.get<UserModelResponse>(
      `/api/workspaces/${wsId}/members/${encodeURIComponent(username)}/user-model`,
    ),
}
